<template>
  <div>
    <right-panel :id="`sidebar-create-task`" width="1200px" :icon="'mdi mdi-plus'" :text="$t('task.create')" @hidden="onHidden">
      <b-row>
        <b-col md="8">
          <div class="pl-5 pr-5">
            <h6 class="mt-4">{{ $t("task.category") }}</h6>
            <filter-select
              :validation="true"
              :isValid="!$v.form.category.$invalid"
              id="taskCategoryFilter"
              ref="taskCategoryFilter"
              :placeholder="$t('task.category')"
              :multiple="false"
              @filter="onCategorySearch"
              :selected="form.category"
              @changed="onCategorySelect"
            />

            <br />
            <sweet-input
              id="name"
              v-model="form.name"
              :isValid="!$v.form.name.$error"
              @input="$v.form.name.$touch()"
              layout="vertical"
              :placeholder="$t('common.name')"
              :label="$t('task.summary')"
              @focus="setActiveElement($event)"
            />
            <br />

            <sweet-textarea
              id="description"
              v-model="form.description"
              :isValid="!$v.form.description.$error"
              @input="$v.form.description.$touch()"
              type="text"
              layout="vertical"
              :placeholder="$t('common.description')"
              :label="$t('process.description')"
              :rows="6"
              @focus="setActiveElement($event)"
            />

            <div class="card card-body  mt-4">
              <h6>Görev Atama Seçenekleri</h6>

              <div>
                <label class="mb-1" :class="form.assignToCausedAccount ? 'text-success' : ''">
                  <b-form-checkbox v-model="form.assignToCausedAccount" switch size="sm" class="custom-checkbox-success">
                    <i class="bx bx-school"></i>
                    {{ $t("system-flow.assign.caused-account") }}
                  </b-form-checkbox>
                </label>
              </div>

              <div>
                <label class="mb-1" :class="form.assignToOrganizationOwner ? 'text-success' : ''">
                  <b-form-checkbox v-model="form.assignToOrganizationOwner" switch size="sm" class="custom-checkbox-success">
                    <i class="bx bx-school"></i>
                    Görevi organizasyon sahibine ata
                  </b-form-checkbox>
                </label>
              </div>

              <div>
                <label class="mb-1" :class="form.assignToAdmin ? 'text-success' : ''">
                  <b-form-checkbox
                    v-model="form.assignToAdmin"
                    switch
                    :disabled="!['PROCESS_CREATED', 'DEPARTMENT_CREATED'].includes(when)"
                    size="sm"
                    class="custom-checkbox-success"
                  >
                    <i class="bx bx-school"></i>
                    Görevi Faaliyet/Birim Yöneticisine Ata
                  </b-form-checkbox>
                </label>
              </div>

              <div>
                <label class="mb-1" :class="form.directAssign ? 'text-success' : ''">
                  <b-form-checkbox v-model="form.directAssign" switch size="sm" class="custom-checkbox-success">
                    <i class="bx bx-school"></i>
                    Görevi seçtiğim role sahip bir kişiye ata
                  </b-form-checkbox>
                </label>
              </div>

              <div v-if="form.directAssign">
                <h6 class="mt-4">Görev hangi roldeki kişiye atansın</h6>
                <filter-select
                  id="roleFilter"
                  ref="roleFilter"
                  :placeholder="$t('role.text')"
                  :searchable="false"
                  :multiple="false"
                  @filter="onRoleSearch"
                  :selected="form.role"
                  @changed="onRoleSelect"
                />
              </div>
            </div>

            <div v-if="linkableTasks.length > 0" class="card card-body  mt-4">
              <h6>Görev İlişikilendir</h6>
              <b-row>
                <b-col>
                  <select v-model="taskRelation" class="form-control form-control-sm">
                    <option v-for="i in linkableTasks" :key="i._id" :value="i">{{ i.name | translate }}</option>
                  </select>
                </b-col>

                <b-col>
                  <select v-model="linkType" class="form-control form-control-sm">
                    <option value="BLOCKS">{{ $t("task.link.blocks") }}</option>
                    <option value="BLOCKED_BY">{{ $t("task.link.blocked-by") }}</option>
                    <option value="RELATED">{{ $t("task.link.related") }}</option>
                    <option value="SUBTASK">{{ $t("task.link.sub-task") }}</option>
                    <option value="PARENT">{{ $t("task.link.parent") }}</option>
                  </select>
                </b-col>
                <b-col md="2">
                  <button class="btn btn-sm btn-secondary" @click="link" :disabled="!linkButtonEnable"><i class="bx bx-link"></i> ilişkilendir</button>
                </b-col>
              </b-row>

              <div v-if="form.taskRelations && form.taskRelations.length > 0">
                <hr />
                <h6 class="mt-4"><i class="bx bx-link"></i> Bu görev ile ilişkilendiriğiniz diğer görevler</h6>

                <div v-for="i in form.taskRelations" :key="'lt' + i">
                  <i class="bx bx-trash text-danger" @click="unlink(i)"></i>
                  <span class="badge badge-secondary m-2">
                    {{ i.type }}
                  </span>
                  {{ i.task.name | translate }}
                </div>
              </div>
            </div>

            <sweet-button @click="ok()" :disabled="$v.$invalid" type="submit" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
              {{ $t("common.save") }}
            </sweet-button>
          </div>
        </b-col>
        <b-col md="4">
          <h4>{{ $t("system-flow.task-definition-templates") }}</h4>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['ORGANIZATION_MEMBER_JOINED', 'ORGANIZATION_MEMBER_ROLE_CHANGED'].includes(when)"
            @click="applyDescriptionTemplate('#workspace#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Çalışma Ortamı Adı
          </b-button>
          <b-button variant="primary" class="btn btn-label btn-sm mr-1 mb-1" @click="applyDescriptionTemplate('#organizasyon#')">
            <i class="bx bx-copy label-icon font-size-18"></i>
            {{ $t("organization.name") }}
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="
              [
                'DEPARTMENT_CREATED',
                'PROCESS_CREATED',
                'DATASOURCE_CREATED',
                'DATASOURCE_UPDATED',
                'DATASOURCE_COLLECT_MINIMIZED',
                'DATASOURCE_TRANSFER_MINIMIZED',
                'DATA_COLLECT_MINIMIZED',
                'DATASUBJECT_TRANSFER_MINIMIZED',
              ].includes(when)
            "
            @click="applyDescriptionTemplate('#departman#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Birim Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="
              [
                'PROCESS_CREATED',
                'DATASOURCE_CREATED',
                'DATASOURCE_UPDATED',
                'DATASOURCE_COLLECT_MINIMIZED',
                'DATASOURCE_TRANSFER_MINIMIZED',
                'DATA_COLLECT_MINIMIZED',
                'DATASUBJECT_TRANSFER_MINIMIZED',
              ].includes(when)
            "
            @click="applyDescriptionTemplate('#faaliyet#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Faaliyet Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="
              [
                'DATASOURCE_CREATED',
                'DATASOURCE_UPDATED',
                'DATASOURCE_COLLECT_MINIMIZED',
                'DATASOURCE_TRANSFER_MINIMIZED',
                'DATA_COLLECT_MINIMIZED',
                'DATASUBJECT_TRANSFER_MINIMIZED',
              ].includes(when)
            "
            @click="applyDescriptionTemplate('#veri kaynağı#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Veri Kaynağı Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATA_COLLECT_MINIMIZED', 'DATASUBJECT_TRANSFER_MINIMIZED'].includes(when)"
            @click="applyDescriptionTemplate('#veri#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Veri Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATASUBJECT_CREATED', 'DATASUBJECT_TRANSFER_MINIMIZED'].includes(when)"
            @click="applyDescriptionTemplate('#veri konusu kişi#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            İlgili Kişi Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATASUBJECT_TRANSFER_MINIMIZED', 'DATASOURCE_TRANSFER_MINIMIZED', 'THIRDPARTY_CREATED', 'THIRDPARTY_DELETED'].includes(when)"
            @click="applyDescriptionTemplate('#üçüncü taraf#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Üçüncü Taraf Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATASUBJECT_TRANSFER_MINIMIZED', 'DATASOURCE_TRANSFER_MINIMIZED'].includes(when)"
            @click="applyDescriptionTemplate('#alıcı grubu#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Alıcı Grubu
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATASOURCE_PHYSICAL_ARCHIVE_CREATED'].includes(when)"
            @click="applyDescriptionTemplate('#fiziksel arşiv ortamı#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Fiziksel Arşiv Ortamı Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATASOURCE_PHYSICAL_ARCHIVE_CREATED'].includes(when)"
            @click="applyDescriptionTemplate('#fiziksel arşiv ortamı kategorisi#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Fiziksel Arşiv Ortamı Kategorisi
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATASOURCE_PHYSICAL_STORAGE_CREATED'].includes(when)"
            @click="applyDescriptionTemplate('#fiziksel saklama ortamı#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Fiziksel Saklama Ortamı Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['DATASOURCE_PHYSICAL_STORAGE_CREATED'].includes(when)"
            @click="applyDescriptionTemplate('#fiziksel saklama ortamı kategorisi#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Fiziksel Saklama Ortamı Kategorisi
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['ORGANIZATION_MEMBER_JOINED', 'ORGANIZATION_MEMBER_ROLE_CHANGED'].includes(when)"
            @click="applyDescriptionTemplate('#kişi#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Kişi Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['ORGANIZATION_MEMBER_JOINED', 'ORGANIZATION_MEMBER_ROLE_CHANGED'].includes(when)"
            @click="applyDescriptionTemplate('#roller#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Kişinin Organizasyondaki Rolleri
          </b-button>

          <b-button variant="primary" class="btn btn-label btn-sm mr-1 mb-1" v-if="['ROADMAP_STAGE_COMPLETED'].includes(when)" @click="applyDescriptionTemplate('#roadmap#')">
            <i class="bx bx-copy label-icon font-size-18"></i>
            Roadmap Adı
          </b-button>

          <b-button
            variant="primary"
            class="btn btn-label btn-sm mr-1 mb-1"
            v-if="['ROADMAP_STAGE_COMPLETED'].includes(when)"
            @click="applyDescriptionTemplate('#roadmap aşaması#')"
          >
            <i class="bx bx-copy label-icon font-size-18"></i>
            Roadmap Aşaması
          </b-button>

          <b-button variant="primary" class="btn btn-label btn-sm mr-1 mb-1" v-if="['POLICY_STATUS_CHANGED'].includes(when)" @click="applyDescriptionTemplate('#tedbir#')">
            <i class="bx bx-copy label-icon font-size-18"></i>
            Tedbir Adı
          </b-button>
        </b-col>
      </b-row>
    </right-panel>
  </div>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";

export default {
  props: ["store", "when"],
  components: { SweetTextarea },
  data() {
    return {
      elementName: "description",
      linkType: null,
      taskRelation: null,
      selectedCompliancePolicy: undefined,
      form: {
        name: undefined,
        description: undefined,
        taskRelations: [],
        category: undefined,
        assignToCausedAccount: false,
        assignToOrganizationOwner: false,
        assignToAdmin: false,
        directAssign: false,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      description: {
        required,
      },
      category: {
        required,
      },
    },
  },
  computed: {
    tasks() {
      return this.$store.getters[`${this.store}/tasks`];
    },
    linkableTasks() {
      let response = this.tasks?.map((i) => ({ _id: i._id, name: i.name }));

      if (this.editedTask) {
        response = response.filter((i) => i._id != this.editedTask._id);
      }

      return response;
    },
    linkButtonEnable() {
      if (!this.linkType || !this.taskRelation || this.form.taskRelations.find((i) => i.task._id == this.taskRelation._id)) {
        return false;
      }
      return true;
    },
    editedTask() {
      return this.$store.getters[`${this.store}/editedTask`];
    },
  },
  watch: {
    editedTask: {
      deep: true,
      immediate: true,
      handler(v) {
        this.reset();
        if (!v) {
          return;
        }
        const taskRelations = v.taskRelations ?? [];
        this.form = { ...this.prepareFormForEdit(v), taskRelations };
      },
    },

    "form.assignToCausedAccount": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form.assignToOrganizationOwner = false;
          this.form.assignToAdmin = false;
          this.form.directAssign = false;
        }
      },
    },
    "form.assignToOrganizationOwner": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form.assignToCausedAccount = false;
          this.form.assignToAdmin = false;
          this.form.directAssign = false;
        }
      },
    },
    "form.assignToAdmin": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form.assignToOrganizationOwner = false;
          this.form.assignToCausedAccount = false;
          this.form.directAssign = false;
        }
      },
    },
    "form.directAssign": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form.assignToOrganizationOwner = false;
          this.form.assignToAdmin = false;
          this.form.assignToCausedAccount = false;
        }
      },
    },
  },
  methods: {
    reset() {
      this.form = {
        name: undefined,
        description: undefined,
        taskRelations: [],
        category: undefined,
        assignToOrganizationOwner: false,
        assignToCausedAccount: false,
        assignToAdmin: false,
        directAssign: false,
      };
    },
    onHidden() {
      this.reset();
      this.$store.commit(`${this.store}/editedTask`, undefined);
    },

    link() {
      if (!this.linkType || !this.taskRelation || this.form.taskRelations.find((i) => i.task._id == this.taskRelation._id)) {
        return;
      }
      this.form.taskRelations = [...this.form.taskRelations, { type: this.linkType, task: this.taskRelation }];

      this.linkType = null;
      this.taskRelation = null;
    },

    unlink(item) {
      this.form.taskRelations = [...this.form.taskRelations.filter((i) => !(i.type == item.type && i.task._id == item.task._id))];
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`managementTaskCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, "scope.value": { value: "system", isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item };
    },
    async onRoleSearch(value, callback) {
      const response = await this.$store.dispatch(`role/paginate`, {
        options: { limit: 200 },
        query: {},
      });

      callback(response.data?.docs ?? []);
    },
    onRoleSelect(item) {
      this.form = { ...this.form, role: { _id: item._id, name: item.name } };
    },

    ok() {
      const payload = {
        _id: this.form._id,
        name: {
          [this.currentLanguage]: this.form.name,
        },
        description: {
          [this.currentLanguage]: this.form.description,
        },
        role: this.form.role,
        category: this.form.category,
        taskRelations: this.form.taskRelations,
        assignToOrganizationOwner: this.form.assignToOrganizationOwner,
        assignToCausedAccount: this.form.assignToCausedAccount,
        assignToAdmin: this.form.assignToAdmin,
        directAssign: this.form.directAssign,
      };

      if (this.editedTask) {
        this.$store.commit(`${this.store}/updateTaskItem`, { task: payload });
      } else {
        this.$store.commit(`${this.store}/addTaskItem`, { task: payload });
      }

      this.reset();
      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task`);
    },

    setActiveElement(e) {
      this.elementName = e.id;
    },
    applyDescriptionTemplate(value) {
      let element = document.getElementById(this.elementName);
      let startPos = element.selectionStart;
      let endPos = element.selectionEnd;
      let cursorPos = startPos;
      let tmpStr = element.value;

      if (value === null) {
        return;
      }

      value = `"${value}" `;
      this.form[this.elementName] = tmpStr.substring(0, startPos) + value + tmpStr.substring(endPos, tmpStr.length);

      setTimeout(() => {
        cursorPos += value.length;
        element.selectionStart = element.selectionEnd = cursorPos;
        this.$forceUpdate();
      }, 10);
    },
  },
};
</script>
